import React, { useEffect, useRef, useState } from 'react';

import styles from './Game.module.scss';
import * as messenger from '../../utils/messenger';
import { encodeIt } from '../../utils/utils';
import Spinner from '../../UI/Spinner/Spinner';
import { useContextSelector } from 'use-context-selector';
import { UIContext } from '../../context/UI/UIContext';
import { isThisGameLastInCourse } from '../../selectors/courseSelector';

function Game({ game = {}, resourceId, globalState }) {
  const { onPageCompleted, goNextPage, setCourseScore, player, course } =
    globalState;
  const iframeRef = useRef();
  const { id, data } = game;
  const dataRef = useRef(data);
  dataRef.current = data;
  const [random, setRandom] = useState();
  const startBlinkNext = useContextSelector(UIContext, (c) => c.startBlinkNext);

  useEffect(() => {
    messenger.init();
    messenger.addOnReceiveMessage('requestParameters', () => {
      // send game data to render on iframe
      const frameWindow = iframeRef.current.contentWindow || null;
      messenger.sendMessage(
        'retrieveParameters',
        encodeIt(dataRef.current),
        frameWindow
      );
      messenger.sendMessage('retrieveParameters');
    });

    messenger.addOnReceiveMessage('setAnswer', (data) => {
      const shouldSetScore = isThisGameLastInCourse(course, resourceId);
      console.log({ score: data.score, shouldSetScore });
      shouldSetScore && setCourseScore(data.score);
      onPageCompleted(() => startBlinkNext());
      goNextPage();
    });

    return () => {
      messenger.remove();
    };
  }, [data, goNextPage, onPageCompleted, setCourseScore]); // eslint-disable-line

  useEffect(() => {
    // force reload iframe when data changes
    setRandom(Math.ceil(Math.random() * 1000));
  }, [data, id]);

  let src = `${process.env.PUBLIC_URL}/assets/games/${id}/index.html`;
  // to avoid random factor when editing (spaming the server requesting media)
  if (player.editMode) src += `?r=${random}`;

  if (!id) return <Spinner />;

  return (
    <iframe
      title={id}
      src={src}
      width="100%"
      height="100%"
      ref={iframeRef}
      frameBorder="0"
      className={styles.Game__iframe}
    />
  );
}

export default Game;
